import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const SavingGraph = ({ good = [],categories=[] }) => {
  const [state] = useState({
    chart: {
      type: "line",
      height: "230px",
      toolbar: {
        show: false,
      },
      backgroundColor: "transparent",
      plotBackgroundColor: "#3C3A77",
      plotBorderWidth: 2,
      plotBorderColor: "#645E86",
      plotBorderRadius: 20,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "Savings (in '000s USD)",
      align: "left",
      style: {
        color: "#D2D2EA",
        fontSize: "13px",
        fontWeight: "500",
      },
    },
    xAxis: {
      categories: categories,
      labels: {
        show: true,
        rotation: -20,
        style: {
          color: "#D2D2EA",
          fontSize: "10px",
          fontWeight: "600",
        },
      },
      //   lineWidth: 0,
    },
    yAxis: {
      // min: 0,
      // max: 100,
      tickAmount: 5,
      title: "",
      labels: {
        format: "{value}",
        style: {
          color: "#D2D2EA",
          fontSize: "10px",
          fontWeight: "600",
        },
      },
      gridLineColor: "#645E86",
      gridLineWidth: 2,
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
        },
      },
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: "Savings",
        data: good,
        color: "#34A853",
        // marker: {
        //   enabled: false,
        // },
      },
    ],
  });

  return (
    <div id="chart">
      <HighchartsReact highcharts={Highcharts} options={state} />
    </div>
  );
};

export default SavingGraph;
